const colors = {
  greyLight: '#E5E8EB',
  greyLight2: '#aab0bc',
  greyLight3: '#e5e5e9',
  greyLight4: '#e2e8f0',
  greyMedium: '#f2f3f5',
  greyModal: '#F4F4F4',
  greyMedium2: '#DADDE1',
  greyDark: '#90949C',
  greyDark2: '#979797',
  greyBorder: '#E0E0E0',
  greyBullet: '#d8dae2d9',
  greyMain: '#616770',
  mikelKors: '#e1c79c',
  greyExtraDark: '#5c626d',
  blackLight: '#1D2129',
  greenExtraLight: '#8de7c1',
  greenGrey: '#b6e2ce',
  greenGreyLight: '#e1faef',
  greenLight: '#B7E9D2',
  greenLight2: '#1CCF83',
  greenLight3: '#2DCE85',
  greenMedium: '#009053',
  greenPoll: '#20CC92',
  greenMedium2: '#009151',
  greenBar: '#a9f5d2',
  greenDark: '#00d081',
  greenDark2: '#b2cbab',
  tealLight: '#FFFFFF',
  tealMedium: '#C6E1EB',
  yellowMedium: '#FFF6D8',
  yellowDark: '#FFC400',
  yellow: '#f0c22c',
  blueLight: '#8ca0f3',
  blueMedium: '#7683E3',
  blueMedium2: '#667de3',

  blueDark: '#1155cc',
  blueBullet: '#a8b0e8',
  blueDark2: '#3a4c9a',
  bluePurple: '#8698F5',
  blueGrey: '#e6e6fa',
  pinkLight: '#FFEEF8',
  pinkMedium: '#fddff5',
  pinkMedium2: '#D3208B',
  pinkDark: '#D5158C',
  tomato: '#E9586A',
  redBar: '#ffc3c3',
  cyanMedium: '#5CB8D6',
  red: '#eb5668',
  red2: '#FF0800',
  violetLight: '#667bd5',
  violetLight2: '#e6e6fa',
  violetDark: '#d780d1',
  analyticGreen: '#D9EAD3',
  analyticYellow: '#FFF2CC',
  analyticGrey: '#aab0bc',
  analyticsGreyLight: '#EFEFEF',
  purpleLight: '#d0d7f3',
  peachLight: '#ffe7dd',
  peachMedium: '#ffccb8',
  privatePoll: '#6C9EEB',
}

export default colors

export const badgeColors = {
  green: {
    text: '#15803d',
    background: '#dcfce7',
    border: '#86efac',
  },
  blue: {
    text: '#1e40af',
    background: '#dbeafe',
    border: '#93c5fd',
  },
  violet: {
    text: '#6d28d9',
    background: '#ede9fe',
    border: '#a78bfa',
  },
  red: {
    text: '#b91c1c',
    background: '#fee2e2',
    border: '#fca5a5',
  },
  yellow: {
    text: '#854d0e',
    background: '#fef9c3',
    border: '#fde047',
  },
  orange: {
    text: '#9a3412',
    background: '#ffedd5',
    border: '#fdba74',
  },
  teal: {
    text: '#115e59',
    background: '#ccfbf1',
    border: '#5eead4',
  },
  pink: {
    text: '#be185d',
    background: '#fce7f3',
    border: '#f9a8d4',
  },
  purple: {
    text: '#6b21a8',
    background: '#f3e8ff',
    border: '#c084fc',
  },
  cyan: {
    text: '#155e75',
    background: '#cffafe',
    border: '#67e8f9',
  },
  gray: {
    text: '#374151',
    background: '#f3f4f6',
    border: '#d1d5db',
  },
  default: {
    text: 'gray.600',
    background: 'gray.100',
    border: 'gray.300',
  },
} as const

export type BadgeColorType = keyof typeof badgeColors
